import { render, staticRenderFns } from "./AdminShowRecentTrips.vue?vue&type=template&id=15de5237&scoped=true&"
import script from "./AdminShowRecentTrips.vue?vue&type=script&lang=js&"
export * from "./AdminShowRecentTrips.vue?vue&type=script&lang=js&"
import style0 from "./AdminShowRecentTrips.vue?vue&type=style&index=0&id=15de5237&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de5237",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15de5237')) {
      api.createRecord('15de5237', component.options)
    } else {
      api.reload('15de5237', component.options)
    }
    module.hot.accept("./AdminShowRecentTrips.vue?vue&type=template&id=15de5237&scoped=true&", function () {
      api.rerender('15de5237', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminShowRecentTrips.vue"
export default component.exports